import React, { useState, useEffect } from 'react';
import Quagga from 'quagga'; // Vonalkódolvasáshoz
import './App.css';

const App = () => {
  const [barcode, setBarcode] = useState('');
  const [product, setProduct] = useState(null);
  const [error, setError] = useState('');
  const [locationAllowed, setLocationAllowed] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isScanning, setIsScanning] = useState(true); // Szkennelés állapot

  // Iroda koordinátái
  const officeCoordinates = {
    lat:  47.37434163411866, 
    lon:  19.044982548316074,   
  };

  // Távolság kiszámítása (km-ben, Haversine formula)
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Föld sugara km-ben
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Távolság km-ben
  };

  // Helymeghatározás ellenőrzése
  const checkLocation = () => {
    if (!navigator.geolocation) {
      setError('A helymeghatározás nem támogatott ezen az eszközön.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const distance = calculateDistance(latitude, longitude, officeCoordinates.lat, officeCoordinates.lon);

        if (distance <= 0.5) {
          setIsAuthorized(true);
        } else {
          setError('Nem tartózkodsz a cégnél.');
        }
        setLocationAllowed(true);
      },
      (error) => {
        console.error('Helymeghatározási hiba:', error);
        setLocationAllowed(false);
        setError('Nem engedélyezted a helymeghatározást.');
      }
    );
  };

  // Kamera inicializálása
  useEffect(() => {
    checkLocation(); // Helymeghatározás ellenőrzése
  }, []);

  useEffect(() => {
    if (isAuthorized && isScanning) {
      Quagga.init(
        {
          inputStream: {
            name: 'Live',
            type: 'LiveStream',
            target: document.querySelector('#scanner'), // Kamera helye
            constraints: {
              facingMode: 'environment', // Hátsó kamera
            },
          },
          decoder: {
            readers: ['code_128_reader', 'ean_reader'],
          },
        },
        (err) => {
          if (err) {
            console.error('Kamera hiba:', err);
            setError('A kamera nem érhető el. Ellenőrizd az engedélyeket!');
            setIsScanning(false); // Kamera leállítása hiba esetén
            return;
          }
          Quagga.start();
        }
      );

      Quagga.onDetected((result) => {
        if (isScanning) {
          const scannedCode = result.codeResult.code;
          setBarcode(scannedCode);
          fetchProductByBarcode(scannedCode);
          setIsScanning(false); // Kamera leállítása szkennelés után
        }
      });

      return () => {
        Quagga.stop(); // Kamera leállítása komponens unmountkor
      };
    }
  }, [isAuthorized, isScanning]);

  // API lekérés a vonalkód alapján
  const fetchProductByBarcode = async (barcode) => {
    try {
      setError('');
      const response = await fetch(`/barcode_api.php?barcode=${barcode}`);
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('Nincs ilyen termék!');
        } else {
          throw new Error('Hiba történt az adatbázis elérésekor.');
        }
      }
      const data = await response.json();
      setProduct(data);

      // 5 másodperc után alapállapotba váltás
      setTimeout(() => {
        setProduct(null);
        setBarcode('');
        setIsScanning(true); // Kamera újraindítása
      }, 5000);
    } catch (err) {
      setError(err.message);
      setProduct(null);

      // 5 másodperc után alapállapotba váltás
      setTimeout(() => {
        setError('');
        setIsScanning(true); // Kamera újraindítása
      }, 5000);
    }
  };

  // Helymeghatározás sikertelenség esetén
  if (locationAllowed === false) {
    return (
      <div className="error">
        <p>{error || 'Engedélyezd a helymeghatározást a használathoz.'}</p>
        <button onClick={checkLocation}>Helymeghatározás Kérése</button>
      </div>
    );
  }

  // Helymeghatározás sikeres, de nincs jogosultság
  if (!isAuthorized) {
    return (
      <div className="error">
        <p>{error || 'Nem tartózkodsz a cégnél.'}</p>
        <button onClick={checkLocation}>Újrapróbálkozás</button>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="header">
        <img src="logo.png" alt="Logó" className="logo" />
        <h1>Árellenőrző</h1>
      </div>
      <div id="scanner" className="scanner"></div>
      {(product || error) && (
        <div className="product-info">
          {product ? (
            <>
              {product.image && (
                <img src={product.image} alt={product.name} className="product-image" />
              )}
              <h2>{product.name}</h2>
              <p>Vonalkód: {product.Barcode}</p>
              <p className="price">Ár: {Math.round(product.price)} Ft</p>
              <p>Készlet: {Math.round(product.stock)} db</p>
            </>
          ) : (
            <p className="error">{error}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default App;
